module.exports = __webpack_public_path__ + "img/header-logo.efed9e81.png";